/**
 * Delivery Status Badge Component
 * Displays a colored badge/icon for property delivery status
 */

import React from "react";
import { getDeliveryStatusConfig } from "../../tools/properties/badgeConfig";
import "./DeliveryStatusBadge.scss";

const DeliveryStatusBadge = ({ status, showLabel = true, size = "medium" }) => {
  const config = getDeliveryStatusConfig(status);
  const Icon = config.icon;

  return (
    <span
      className={`delivery-status-badge ${status} size-${size}`}
      title={config.label}
      style={{ color: config.color }}
    >
      <Icon className="status-icon" />
      {showLabel && <span className="status-label">{config.label}</span>}
    </span>
  );
};

export default DeliveryStatusBadge;
